export const CHARACTERS = [
  "Longhook",
  "Suriel",
  "Lindon",
  "Yerin",
  "Eithan",
  "Ozriel",
  "Orthos",
  "Little Blue",
  "Akura Mercy",
  "Dross",
  "Ziel",
  "Jai Long",
  "Jai Chen",
  "Fisher Gesha",
  "Wei Shi Kelsa",
  "Makiel",
  "Gadrael",
  "Durandiel",
  "Telariel",
  "Razael",
  "Zakariel",
  "Adriel",
  "Pariana of the Titans",
  "Kiuran of the Hounds",
  "Iri the Angler",
  "Mad King",
  "Silverlord",
  "The Horseman",
  "Akura Malice",
  "Seshethkunaaz",
  "Reigan Shen",
  "Tiberian Arelius",
  "Sha Miara",
  "Emriss Silentborn",
  "Silent King",
  "Bleeding Phoenix",
  "Weeping Dragon",
  "Wandering Titan",
  "Northstrider",
  "Larian",
  "Maten Kei",
  "Eight Man empire member not Larian",
  "Red Faith",
  "Akura Fury",
  "Akura Charity",
  "Akura Justice",
  "Akura Pride",
  "Akura Grace",
  "Akura Harmony",
  "Akura Courage",
  "Akura Douji",
  "Sha Leiala",
  "Sha Relliar",
  "Xorrus",
  "Sopharanatoth",
  "Ekerinatoth",
  "Garrylondryth",
  "Yushi",
  "Chryleia",
  "Cladia Arelius sage of thousand eyes",
  "Cassias Arelius",
  "Veris Arelius",
  "Altavian Arelius",
  "Arelius member",
  "Ozmanthus Arelius",
  "Naru Huan",
  "Naru Gwei",
  "Naru Saeya",
  "Naru Jing",
  "Jai Daishou",
  "Jai Sen",
  "Jai Hara",
  "Renfei",
  "Bai Rou",
  "Gaien Arelius",
  "Sandviper Gokren",
  "Sandviper Kral",
  "Sandviper member",
  "Jai member",
  "Fisher Ragahn",
  "Fisher Lokk",
  "Chon Ma",
  "Kotai Shou",
  "Kotai Reina",
  "Li Min Redflower",
  "Mu Enkai",
  "Elder Whisper",
  "Wei Jin Sairus",
  "Wei Jin Amon",
  "Wei Mon Keth",
  "Wei Mon Teris",
  "Wei Mon Eri",
  "Wei Shi Jaran",
  "Wei Shie Seisha",
  "Li Markuth",
  "Li Ten Jana",
  "Kazan Ma",
  "Kazan Shet",
  "Elder Whitehall",
  "Elder Rahm",
  "Elder Anses",
  "Seishen Dakata",
  "Riyusai Meira",
  "Seishen Kiro",
  "Seishen Daji",
  "Min Shuei Frozen Blade",
  "Redmoon Herald",
  "Yan Shoumei",
  "Blacksword",
  "Crusher",
  "Sage of Calling Storms",
  "Calan Archer",
  "Therian Nills",
  "Brother Aekin",
  "Kenvata Nasuma Juvari",
  "Beast King",
  "Ninecloud Soul",
  "Subject One",
  "Timaias Adama Endless Sword"

];

export const ADVANCEMENTS = [
  "Foundation",
  "Copper", 
  "Iron",
  "Jade",
  "Lowgold",
  "Highgold", 
  "Truegold",
  "Underlord",
  "Overlord", 
  "Archlord",
  "Sage",
  "Herald", 
  "Monarch",
  "Dreadgod",
  "Ascended",
  "Dross"
];

export const BOOKS = [
  "Unsouled",
  "Soulsmith", 
  "Blackflame",
  "Skysworn",
  "Ghostwater",
  "Underlord",
  "Uncrowned", 
  "Wintersteel",
  "Bloodline",
  "Reaper",
  "Dreadgod",
  "Waybound" 
];

export const searchCharacters = (searchTerm, limit = 8) => {
  if (!searchTerm.trim()) return [];
  
  const term = searchTerm.toLowerCase();
  return CHARACTERS.filter(character =>
    character.toLowerCase().includes(term)
  ).slice(0, limit);
};

export const isValidCharacter = (character) => {
  return CHARACTERS.some(char => 
    char.toLowerCase() === character.toLowerCase()
  );
};
 
export const isValidAdvancement = (advancement) => {
  return ADVANCEMENTS.some(adv => 
    adv.toLowerCase() === advancement.toLowerCase()
  );
};

export const isValidBook = (book) => {
  return BOOKS.some(b => 
    b.toLowerCase() === book.toLowerCase()
  );
};